import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useBillRequestB2CDetail = (id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [billInfo, setBillInfo] = useState<BillInfoDto>();
  const [billItems, setBillItems] = useState<BillItemB2CInfoDto[]>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const { isLoading } = useQuery(
    [endpoints.bill.b2c.info.request, {id: id}],
    () =>
      fetcher.bill.postBillRequestB2cInfo({id: id}),
    {
      onSuccess: (res: BillB2CInfoResDto) => {
        switch (res.code) {
          case 200:
            setBillInfo(res.result?.info);
            setBillItems(res.result?.items);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );


  const { mutate: billInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.bill.b2c.info.insert],
    fetcher.bill.postBillInfoInsertB2C,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;              
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { billInfo, billItems, insertSuccess, billInsert };
};

export default useBillRequestB2CDetail;
